import React, { Component } from 'react';
import './App.css';
import ScreenContext from './ScreenContext';
import img_elImage from './images/DownloadNow_elImage_575651.png';
import img_elImage2 from './images/DownloadNow_elImage2_399085.png';

export default class DownloadNow extends Component {

  static contextType = ScreenContext;

  // This component doesn't use any properties

  constructor(props) {
    super(props);
    
    this.state = {
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }

  onClick_elImage = async () => {
    window.open('https://apps.apple.com/us/app/portsy/id1533659079', '_blank');
  
  }
  
  
  onClick_elImage2 = async () => {
    window.open('https://play.google.com/store/apps/details?id=com.portsy.portsy', '_blank');
  
  }
  
  
  render() {
    const style_elTextBlock = {
      fontSize: 60.0,
      color: 'white',
      textAlign: 'center',
     };
    const style_elImage = {
      backgroundImage: 'url('+img_elImage+')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
      backgroundSize: 'cover',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const style_elImage2 = {
      backgroundImage: 'url('+img_elImage2+')',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
      backgroundSize: 'cover',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    
    return (
      <div className="DownloadNow appBg">
        <div className="layoutFlow">
          <div className="elTextBlock">
            <div className="font-caesarDressingRegular" style={style_elTextBlock}>
              <div>{this.context.locStrings.downloadnow_textblock_80370}</div>
            </div>
          </div>
          
          <div className="elImage">
            <div style={style_elImage} onClick={this.onClick_elImage}  />
          </div>
          
          <div className="elImage2">
            <div style={style_elImage2} onClick={this.onClick_elImage2}  />
          </div>
        </div>
        
      </div>
    )
  }
  
}
